import styled from "styled-components";
import { modalActionStyles } from "./modalActionStyles";
import React from "react";
import i18n from "../i18n";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faHourglassStart,
  faDoorOpen,
  faUtensils,
  faUser,
  faEquals,
  faHourglassEnd,
  faPowerOff,
  faX,
  faXmark,
  faTable,
  faCircle,
  faChair,
  faHourglassHalf,
} from "@fortawesome/free-solid-svg-icons";
import { faFreebsd } from "@fortawesome/free-brands-svg-icons";

export const ContainerBox = styled.div`
  width: 100%;
  margin: 0;
  background-color: #ffffff;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 46px;
  padding: 9px 0;
  background-color: #ffffff;
  color: #33282a;
  border-bottom: 1px solid #efedeb;
  border-radius: 0;
  gap: 12px;
`;

export const Body = styled.div`
  height: 300px;
  overflow-y: auto;
  padding: 12px 14px 16px;
  /* Style the scrollbar */
  &::-webkit-scrollbar {
    width: 8px; /* Scrollbar width */
    padding-bottom: 10px !important;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* Light gray track */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Darker gray thumb */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Slightly darker on hover */
  }
`;

export const OrangeButton = styled.button`
  min-height: 36px;
  padding: 7px 12px;
  background-color: #ee754c;
  color: white;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 600;
  border: none;
  border-radius: 9px;
  cursor: pointer;
  transition: background-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;

  &:hover {
    background-color: #ee561b;
    box-shadow: 0 5px 14px rgba(75, 51, 53, 0.14);
    transform: translateY(-1px);
  }

  &:active {
    box-shadow: none;
    transform: translateY(0);
  }
`;

export const Title = styled.h4`
  margin: 0;
  font-weight: 600;
  color: var(--app-orange, #ee754c);
  font-size: 14px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: none;
  min-height: 100%;
  margin: 0;
  padding: clamp(16px, 2vw, 28px);

  @media (max-width: 768px) {
    padding: 16px 12px 24px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  min-height: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  background: transparent;
  color: #33282a;
  border: 0;
  border-radius: 0;
  margin-bottom: 18px;
  box-shadow: none;
  position: static;
`;

export const CardHeaderTitle = styled.h4`
  margin: 0;
  font-weight: 750;
  color: var(--app-orange, #ee754c);
  font-size: clamp(19px, 1.7vw, 24px);
  letter-spacing: -0.035em;
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
  width: 100%;
`;

export const InsideFormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`;

export const Input = styled.input`
  min-height: 32px;
  padding: 5px 8px;
  font-size: 12px;
  border: 1px solid #e5e0d7;
  border-radius: 8px;
  outline: none;
  width: 60px;
  transition: border 0.2s ease-in-out;
  color: #99b0ad;

  &:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 3px rgba(238, 117, 76, 0.18);
  }
`;

export const InlineText = styled.span`
  margin: 0 6px;
  font-size: 12px;
  color: #99b0ad;
`;

export const StyledLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
  margin-bottom: 1px;
  margin-top: 15px;
`;
export const StyledInput = styled.input`
  width: 100%;
  min-height: 38px;
  padding: 8px 11px;
  font-size: 13px;
  border: 1px solid #e5e0d7;
  margin-bottom: 1rem;
  border-radius: 10px;
  background-color: #fff;
  color: #4b3335;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;

  &:focus {
    border-color: #ee754c;
    background-color: #fff;
    box-shadow: 0 0 0 3px rgba(238, 117, 76, 0.18);
    outline: none;
  }

  &::placeholder {
    color: #aaa;
  }
`;

/* interface FormattedDateProps {
  date: Date | string;
}

export const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  const parsedDate = new Date(date);

  const weekday = parsedDate.toLocaleDateString("pt-PT", { weekday: "short" });
  const day = parsedDate.getDate().toString().padStart(2, "0");
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
  const year = parsedDate.getFullYear();

  return <>{`${weekday}, ${day}-${month}-${year}`}</>;
};
 */

export const ButtonGap = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 7px 13px;
  border: none;
  border-radius: 11px;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: ${({ $fontSize }) => $fontSize || "12px"};
  font-weight: 600;
  cursor: pointer;
  background-color: ${({ $color }) => $color || "#007bff"};
  color: white;
  transition: background-color 0.18s ease-in-out, box-shadow 0.18s ease-in-out,
    transform 0.18s ease-in-out;
  white-space: nowrap;
  flex: 0 0 auto;

  &:hover {
    background-color: ${({ $color }) => darkenColor($color || "#007bff", 0.1)};
    box-shadow: 0 6px 16px rgba(42, 31, 33, 0.12);
    transform: translateY(-1px);
  }

  &:active {
    box-shadow: none;
    transform: translateY(0);
  }

  &:disabled {
    background-color: #d8d8d8 !important;
    color: #747474;
    cursor: not-allowed !important;
    box-shadow: none;
    transform: none;
  }

  @media (max-width: 576px) {
    padding: 7px 11px;
    font-size: 12px;
    min-height: 38px;
  }
`;

// Helper function to darken the hover color
function darkenColor(hex, amount) {
  try {
    let col = hex;
    if (col.startsWith("#")) col = col.slice(1);

    const num = parseInt(col, 16);
    let r = (num >> 16) - amount * 255;
    let g = ((num >> 8) & 0x00ff) - amount * 255;
    let b = (num & 0x0000ff) - amount * 255;

    r = Math.max(0, r);
    g = Math.max(0, g);
    b = Math.max(0, b);

    return `rgb(${r}, ${g}, ${b})`;
  } catch {
    return hex;
  }
}

export const ModernButton = ({
  children,
  color,
  fontSize,
  onClick,
  style,
  type = "button",
  disabled = false,
}) => {
  return (
    <StyledButton
      $color={color}
      onClick={onClick}
      style={style}
      $fontSize={fontSize}
      type={type}
      disabled={disabled}
    >
      {children}
    </StyledButton>
  );
};

const getAppLocale = () => {
  const language = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  return language === "pt" ? "pt-PT" : language === "es" ? "es-ES" : "en-GB";
};

// A reservation date as the calendar day it names. "2026-09-18" given to
// new Date() is UTC midnight, which is the previous evening anywhere west of
// UTC; read it as local instead. Anything else goes through Date as before.
const toCalendarDate = value => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || "").trim());
  const d = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

//DATE FORMAT: Sex., 18/09 - and Sex., 18/09/2027 outside the current year.
// For cards read at a glance: restaurants plan by day of the week, and the year
// is almost always this one, so the weekday takes its place.
export const DefaultDateWeekday = ({ date }) => {
  const d = toCalendarDate(date);
  if (!d) return <>{date}</>;
  const options = { weekday: "short", day: "2-digit", month: "2-digit" };
  if (d.getFullYear() !== new Date().getFullYear()) options.year = "numeric";
  const formatted = d.toLocaleDateString(getAppLocale(), options);
  return <>{formatted.charAt(0).toUpperCase() + formatted.slice(1)}</>;
};

//DATE FORMAT: Sábado, 19 de Abril de 2025
export const DefaultDateExtended = ({ date }) => {
  const d = new Date(date);
  const formatted = d.toLocaleDateString(getAppLocale(), {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return <>{formatted}</>;
};

export const DefaultDate = ({ date }) => {
  const d = new Date(date);
  const formatted = d.toLocaleDateString(getAppLocale(), {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return <>{formatted}</>;
};

export const DefaultDateUpper = ({ date }) => {
  const d = new Date(date);
  const formatted = d.toLocaleDateString(getAppLocale(), {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const upperFirst = formatted.charAt(0).toUpperCase() + formatted.slice(1);

  return <>{upperFirst}</>;
};

export const DefaultDateSmall = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return <>{formatDate(date)}</>;
};

//DATE FORMAT: 19/04/2025, 14:32
export const DefaultDateSmallMins = ({ date }) => {
  const formatDate = (date) => {
    const d = new Date(date);

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    const hours = d.getHours().toString().padStart(2, "0");
    const minutes = d.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}:${minutes}`;
  };

  return <>{formatDate(date)}</>;
};

export const ErrorMessageBox = styled.div`
  background-color: #ffeded;
  color: #b00020;
  border-left: 5px solid #b00020;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 20px;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CloseIcon = styled(FontAwesomeIcon).attrs({ icon: faXmark })`
  position: absolute;
  right: 18px;
  font-size: 17px;
  color: #756a6c;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ee754c;
  }
`;

export const CustomModal = styled(({ className, ...props }) => (
  <Modal {...props} className={className} backdrop="static" />
))`
  .modal-dialog {
    max-width: 520px;
    width: calc(100% - 20px);
    margin: 1.5rem auto;
  }

  .modal-content {
    border-radius: 16px;
    border: 1px solid rgba(229, 224, 215, 0.8);
    box-shadow: 0 24px 70px rgba(75, 51, 53, 0.16);
    overflow: hidden;
  }

  .modal-header {
    background-color: #ffffff;
    border: none;
    border-bottom: 1px solid #ece6de;
    min-height: 58px;
    padding: 1rem 1.25rem;
  }

  .modal-title {
    font-weight: 700;
    font-size: 17px;
    color: var(--app-orange, #ee754c);
  }

  .modal-body {
    padding: 1.25rem;
    overflow: auto;
  }

  .modal-footer {
    background-color: white;
    border: none;
    border-top: 1px solid #f1ece7;
    padding: 1rem 1.25rem;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  @media (max-width: 576px) {
    .modal-body {
      padding: 0.75rem;
    }
  }

  ${modalActionStyles}
`;
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(33, 33, 33, 0.5);
  z-index: 1040;
`;

export const ConfirmationModal = styled(({ className, ...props }) => (
  <Modal {...props} className={className} backdrop="static" />
))`
  .modal-dialog {
    max-width: 420px;
    width: calc(100% - 20px);
    z-index: 1500 !important;
  }

  .modal-content {
    border-radius: 16px;
    border: 1px solid rgba(229, 224, 215, 0.8);
    box-shadow: 0 24px 70px rgba(75, 51, 53, 0.16);
    overflow: hidden;
  }

  .modal-header {
    background-color: #ffffff;
    border: none;
    border-bottom: 1px solid #ece6de;
    min-height: 58px;
    padding: 1rem 1.25rem;
  }

  .modal-title {
    font-weight: 700;
    font-size: 17px;
    color: var(--app-orange, #ee754c);
  }
`;

export const ModernTextInput = styled.input.attrs({
  type: "text",
})`
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  background-color: #fff;
  color: #333;

  &:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 3px rgba(238, 117, 76, 0.2);
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const statusToGroup = {
  accepted: "A CHEGAR",
  Accepted_edit: "A CHEGAR",
  Rejected_edition: "A CHEGAR",
  Accepted_With_Table: "A CHEGAR",
  Accepted_Without_Table: "A CHEGAR",
  waiting_list: "À PORTA",
  pending_restaurant: "REST",
  edited: "REST",
  pending_customer: "CLIENTE",
  late: "ATRASADA",
  attended: "FINALIZADA",
  completed: "Mesa livre",
  no_show: "CANCELADAS",
  cancelled_customer: "CANCELADAS",
  cancelled_restaurant: "CANCELADAS",
  Cancelled: "CANCELADAS",
};

export const iconStatusMap = {
  "A CHEGAR": {
    icon: faHourglassStart,
    label: "Confirmada",
    color: "#99b0ad",
    color_variation_1: "#2F855A", // green = confirmed / arriving
    color_variation_2: "#99b0ad", // current
  },

  ATRASADA: {
    icon: faHourglassEnd,
    label: "Atrasadas",
    color: "#EE754C",
    color_variation_1: "#B45309", // dark amber/orange = delay / attention
    color_variation_2: "#EE754C", // current
  },

  "À PORTA": {
    icon: faDoorOpen,
    label: "Na fila à porta",
    color: "#EE754C",
    color_variation_1: "#EE754C", // purple = active/special state
    color_variation_2: "#EE754C", // current
  },

  REST: {
    icon: faUtensils,
    label: "A aguardar aceitação do restaurante",
    color: "#EE754C",
    color_variation_1: "#ebab21", // teal = restaurant action
    color_variation_2: "#EE754C", // current
  },

  CLIENTE: {
    icon: faUser,
    label: "Aguarda reconfirmação do cliente",
    color: "#99b0ad",
    color_variation_1: "#3b7c94", // blue = customer action
    color_variation_2: "#99b0ad", // current
  },

  ESPERA: {
    icon: faHourglassHalf,
    label: "Lista de espera",
    color: "#B45309",
    color_variation_1: "#A16207", // dark yellow/gold = waiting
    color_variation_2: "#B45309", // current
  },

  FINALIZADA: {
    icon: faChair,
    label: "Mesa ocupada",
    color: "#99b0ad",
    color_variation_1: "#475569", // slate = occupied / neutral
    color_variation_2: "#99b0ad", // current
  },

  "Mesa livre": {
    icon: faCircle,
    label: "Mesa livre",
    color: "#99b0ad",
    color_variation_1: "#15803D", // dark green = available
    color_variation_2: "#99b0ad", // current
  },

  CANCELADAS: {
    icon: faX,
    label: "Canceladas",
    color: "#99b0ad",
    color_variation_1: "#D94B4B", // dark red = cancelled
    color_variation_2: "#99b0ad", // current
  },

  TOTAL: {
    icon: faEquals,
    label: "Total",
    color: "#99b0ad",
    color_variation_1: "#1F2937", // dark neutral = total
    color_variation_2: "#99b0ad", // current
  },
};

export const labelColors = {
  "A CHEGAR": "#5E9C7C",
  "À PORTA": "#5E9C7C",
  REST: "#d9b645",
  CLIENTE: "#d9b645",
  ATRASADA: "#ba6f32",
  FINALIZADA: "#0fa644",
  "Mesa livre": "#0fa644",
  CANCELADAS: "#822839",
};

export const statusGroups = {
  "A CHEGAR": [
    "accepted",
    "Accepted_edit",
    "Rejected_edition",
    "Accepted_With_Table",
    "Accepted_Without_Table",
  ],
  "À PORTA": ["waiting_list"],
  REST: ["pending_restaurant", "edited"],
  CLIENTE: ["pending_customer"],
  ATRASADA: ["late"],
  FINALIZADA: ["attended"],
  CANCELADAS: [
    "no_show",
    "cancelled_customer",
    "cancelled_restaurant",
    "Cancelled",
  ],
  "Mesa livre": ["completed"],
};

// Container for grouped sections (cards)
export const SettingsCard = styled.div`
  background: white;
  border: 0;
  border-bottom: 1px solid #efedeb;
  border-radius: 0;
  padding: 18px 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 576px) {
    padding: 14px 0;
  }
`;

// Section title styling
export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #33282a;
  width: 100%;
  text-align: left;
  letter-spacing: -0.015em;
`;

// Default paragraph-like text
export const Text = styled.span`
  font-size: 12px;
  color: #6f7775;
  display: block;
  margin-bottom: 16px;
  margin-top: 4px;
  line-height: 1.55;
`;

// Responsive grid layout for wrapping cards
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  column-gap: 28px;
  row-gap: 0;
  margin-bottom: 24px;

  @media (max-width: 420px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0px 5px;
  height: auto;

  @media (max-width: 768px) {
    padding-top: 0px;
    margin-top: 0px;
    justify-content: center;
  }
`;

// Inline spacing element used for layout adjustments
export const CustomSpan = styled.span`
  margin: 0 8px;
  display: inline-block;
`;

// Reusable select with focus & hover styles
export const StyledSelect = styled.select`
  width: auto;
  min-width: 140px;
  height: 36px;
  font-size: 12px;
  padding: 0 10px;
  border: 1px solid #e8e4e2;
  border-radius: 11px;
  background-color: #fff;
  box-shadow: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  color: #333;
  outline: none;
  appearance: none;
  cursor: pointer;

  &:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.25);
  }

  &:hover {
    border-color: #ee754c;
  }
`;
// Container for password input and icon
export const PasswordContainer = styled.div`
  position: relative;
`;

// Password input with space for toggle icon
export const StyledPasswordInput = styled(StyledInput)`
  padding-right: 40px;
`;

// Toggle icon for show/hide password
export const PasswordToggleIcon = styled.div`
  position: absolute;
  top: 40%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;

  svg {
    font-size: 18px;
    color: #ee754c;
  }
`;
